export const AGENT_CASES_PATH = "/agent/cases";
